module.exports = __webpack_public_path__ + "static/waldo-f25383fccc92c057182f7f88ff989df6.png";